module.exports = __webpack_public_path__ + "static/media/login.c203875f.png";